var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 123,
    viewBox: "0 0 133 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.9522 18.2161C99.6995 16.1413 99.4444 13.0249 97.2368 11.4487C87.3239 4.37052 75.497 0.373072 63.2477 0.0248373C49.3566 -0.370071 35.7413 3.95128 24.6205 12.2847C13.4997 20.618 5.52901 32.4722 2.00744 45.9152C-1.51413 59.3583 -0.379004 73.5978 5.22784 86.3132C10.8347 99.0286 20.5827 109.47 32.8833 115.937C45.1839 122.403 59.3119 124.513 72.9649 121.922C86.618 119.331 98.9912 112.193 108.068 101.67C116.072 92.3913 121.097 80.9631 122.557 68.8702C122.882 66.1773 120.753 63.8871 118.043 63.7779C115.332 63.6687 113.071 65.7834 112.705 68.4712C111.361 78.3442 107.184 87.6566 100.63 95.2542C93.003 104.096 82.6061 110.094 71.1337 112.271C59.6614 114.448 47.7899 112.675 37.454 107.242C27.1181 101.808 18.9271 93.0344 14.2158 82.3499C9.50448 71.6655 8.55066 59.7004 11.5098 48.4045C14.4689 37.1086 21.1664 27.1478 30.511 20.1455C39.8555 13.1431 51.2962 9.51199 62.9685 9.84382C72.9982 10.129 82.6909 13.3257 90.8869 18.992C93.1182 20.5345 96.2049 20.2909 97.9522 18.2161Z",
    fill: "#232F6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123 19.1965L62.8777 79.6301L35.5493 52.1603",
    stroke: "#232F6A",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessMessage);
export default __webpack_public_path__ + "static/media/success-message.eaec2103c295b8d16dc81c032b7733eb.svg";
export { ForwardRef as ReactComponent };